import React from 'react';
import { DropZone } from './DropZone'
import { FileList } from './FileList'

interface ComponentNameProps {
  onChange: any;
  text?: string;
  warningSupport?: string;
  warningOnly?: string;
}

const DropPanel: React.FC<ComponentNameProps> = props => {
  const { } = props;
  const [isDropActive, setIsDropActive] = React.useState(false)
  const [files, setFiles] = React.useState<File[]>([])

  const onDragStateChange = React.useCallback((dragActive: boolean) => {
    setIsDropActive(dragActive)
  }, [])

  const processFile = (file: File) => {
    var reader = new FileReader();
    reader.readAsText(file);
  }


  const onFilesDrop = React.useCallback((files: File[]) => {
    setFiles(files);
    props.onChange(files);

    files.map(f => processFile(f));
  }, [])

  return (
    <div style={{ fontWeight: 600 }}>
      <DropZone onDragStateChange={onDragStateChange} onFilesDrop={onFilesDrop}>
        <h2>

          <span style={{ fontWeight: 600 }}>
            {props.text}
          </span>
        </h2>
        {files.length === 0 ? (
          <span>No files to upload</span>
        ) : (
          <span>Files to upload: {files.length}</span>
        )}


        <FileList files={files} />
        <span className='spectrum-zip-type' style={{ bottom: '.3em' }}>
          <ul style={{ listStyleType: 'none', paddingInlineStart: '10px' }}>
            <li>
              <span style={{ whiteSpace: 'pre-line' }}>{props.warningSupport}</span>
            </li>
            <li>
              <span>{props.warningOnly}</span>
            </li>
          </ul>
        </span>
      </DropZone>
    </div>
  )
}

export default React.memo(DropPanel)
